
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1hgMC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $eXmBZ = parcelRequire("eXmBZ");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $euL71 = parcelRequire("euL71");


var $dPJCf = parcelRequire("dPJCf");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bQm3c = parcelRequire("bQm3c");


var $dmDX7 = parcelRequire("dmDX7");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $6d27bc1ba96adced$export$64ed4f32859160d1 = /*#__PURE__*/ function(AccessType) {
    AccessType["EDIT"] = "EDIT";
    AccessType["VIEW"] = "VIEW";
    return AccessType;
}({});











var $a3fRD = parcelRequire("a3fRD");


var $3sFtD = parcelRequire("3sFtD");

const $74dcdc5559d29390$var$i18n = (0, $cgtv4.defineMessages)({
    successTitle: {
        id: "grant-access-dialog.request-access-popup.success-flag-title",
        defaultMessage: "Request sent"
    },
    successContent: {
        id: "grant-access-dialog.request-access-popup.success-flag-content",
        defaultMessage: "We\u2019ve asked the content owner to give you edit access. You\u2019ll get an email once the request is approved."
    },
    errorTitle: {
        id: "grant-access-dialog.request-access-popup.error-flag-title",
        defaultMessage: "We couldn\u2019t send your request"
    },
    errorContent: {
        id: "grant-access-dialog.request-access-popup.error-flag-content",
        defaultMessage: "We ran into a problem processing your request. Refresh and try again."
    },
    successIconLabel: {
        id: "grant-access-dialog.request-access-popup.success-icon-label",
        defaultMessage: "Success"
    },
    errorIconLabel: {
        id: "grant-access-dialog.request-access-popup.error-icon-label",
        defaultMessage: "Error"
    }
});
const $74dcdc5559d29390$export$debd49be6c80c49e = (flagHandler)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const showSuccessFlag = ()=>flagHandler.showSuccessFlag({
            id: `request-access-success-${Date.now()}`,
            title: formatMessage($74dcdc5559d29390$var$i18n.successTitle),
            description: formatMessage($74dcdc5559d29390$var$i18n.successContent),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                label: formatMessage($74dcdc5559d29390$var$i18n.successIconLabel),
                color: "var(--ds-icon-success, #6A9A23)",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    const showErrorFlag = ()=>flagHandler.showErrorFlag({
            id: `request-access-error-${Date.now()}`,
            title: formatMessage($74dcdc5559d29390$var$i18n.errorTitle),
            description: formatMessage($74dcdc5559d29390$var$i18n.errorContent),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: formatMessage($74dcdc5559d29390$var$i18n.errorIconLabel),
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};









var $xQxzY = parcelRequire("xQxzY");







const $3a3b3829438f4478$var$useUserPageAccessTypeContentOperationsQuery = (0, $eSUdr.default)`query useUserPageAccessTypeContentOperationsQuery($id:ID!){singleContent(id:$id){id type operations{operation targetType}}}`;
const $3a3b3829438f4478$export$577e938c860c1afa = (contentId)=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)($3a3b3829438f4478$var$useUserPageAccessTypeContentOperationsQuery, {
        variables: {
            id: contentId
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (error) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
    }, [
        error
    ]);
    const accessTypes = (0, $42omo.useMemo)(()=>{
        const contentNode = data?.singleContent;
        const operations = contentNode?.operations ?? [];
        const contentType = contentNode?.type ?? undefined;
        const result = [];
        // Check if the user has the view permission
        if (operations.find((op)=>op?.operation === 'read' && op.targetType === contentType)) result.push('VIEW');
        // Check if the user has the edit permission
        if (operations.find((op)=>op?.operation === 'update' && op.targetType === contentType)) result.push('EDIT');
        return result;
    }, [
        data
    ]);
    return {
        accessTypes: accessTypes,
        error: error,
        loading: loading
    };
};


const $4542b58e124be250$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "grant-access-dialog.request-access-popup.flag-title",
        defaultMessage: "Ask to edit this content?"
    },
    content: {
        id: "grant-access-dialog.request-access-popup.flag-content",
        defaultMessage: "You\u2019ll get an email when your request is approved."
    },
    requestBtn: {
        id: "grant-access-dialog.request-access-popup.approve-btn",
        defaultMessage: "Ask to edit"
    }
});
// Only allowed value is the string `true`
const $4542b58e124be250$var$QUERY_PARAM_NAME = 'redirectedFromRestrict';
const $4542b58e124be250$var$useQueryParamRedirectedFromRestrict = (0, $dPJCf.createSingleQueryParamHook)($4542b58e124be250$var$QUERY_PARAM_NAME);
// Flag id
const $4542b58e124be250$var$FLAG_ID = 'request-edit-access';
// GraphQL endpoints - not reusable due to eslint rule
const $4542b58e124be250$var$RequestAccessPopupRequestAccessMutation = (0, $eSUdr.default)`mutation RequestAccessPopupRequestAccessMutation($accessType:AccessType!$pageId:String!){requestPageAccess(requestPageAccessInput:{accessType:$accessType pageId:$pageId}){displayName}}`;
const $4542b58e124be250$export$a1b413940dee8e5e = (contentId, flags)=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isRedirectedFromRestrict = $4542b58e124be250$var$useQueryParamRedirectedFromRestrict();
    const { isLoadingForFirstTime: isLoadingForFirstTime, pendingRequestExists: pendingRequestExists } = (0, $dmDX7.usePendingRequestExists)({
        contentId: contentId
    });
    const shouldSkip = Boolean(// No SSR
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    // Not available in Free edition
    edition === (0, $euL71.ConfluenceEdition).FREE || // No particular query param
    !isRedirectedFromRestrict || // Query to check if user has a pending access request is still loading
    isLoadingForFirstTime || // If a pending request exists, show no flag
    pendingRequestExists);
    const { showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag } = (0, $74dcdc5559d29390$export$debd49be6c80c49e)(flags);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { accessTypes: accessTypes, error: contentPermissionError } = (0, $3a3b3829438f4478$export$577e938c860c1afa)(contentId);
    const [requestAccessMutation, { error: requestAccessError }] = (0, $1KmJq.useMutation)($4542b58e124be250$var$RequestAccessPopupRequestAccessMutation, {
        onCompleted: ()=>{
            showSuccessFlag();
        },
        onError: ()=>{
            showErrorFlag();
        }
    });
    const reportPopupEvent = (0, $42omo.useCallback)((analyticEvtType)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: analyticEvtType === 'request' ? 'requestEditAction' : 'dismissRequestEditPopupAction',
                source: 'requestAccessPopup',
                attributes: {
                    contentId: contentId,
                    accessTypes: accessTypes.join(',')
                }
            }
        }).fire();
        // Decision has been made. No more popups needed.
        setQueryParams({
            [$4542b58e124be250$var$QUERY_PARAM_NAME]: undefined
        });
    }, [
        setQueryParams,
        contentId,
        createAnalyticsEvent,
        accessTypes
    ]);
    const requestAccess = (0, $42omo.useCallback)(()=>{
        // Dismiss the popup first (unblocking the UI)
        flags.hideFlag($4542b58e124be250$var$FLAG_ID);
        reportPopupEvent('request');
        // Send the request
        return requestAccessMutation({
            variables: {
                accessType: (0, $6d27bc1ba96adced$export$64ed4f32859160d1).EDIT,
                pageId: contentId
            }
        });
    }, [
        contentId,
        reportPopupEvent,
        requestAccessMutation,
        flags
    ]);
    // Error handling
    (0, $42omo.useEffect)(()=>{
        if (shouldSkip) return;
        if (contentPermissionError) (0, $5ZqQS.getMonitoringClient)().submitError(contentPermissionError, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
        if (requestAccessError) {
            (0, $5ZqQS.getMonitoringClient)().submitError(requestAccessError, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'errored',
                    actionSubject: 'requestEditSent',
                    source: 'requestEditPopup',
                    attributes: {
                        contentId: contentId,
                        accessTypes: accessTypes.join(',')
                    }
                }
            }).fire();
        }
    }, [
        accessTypes,
        contentPermissionError,
        requestAccessError,
        shouldSkip,
        createAnalyticsEvent,
        contentId
    ]);
    // When the component loads
    (0, $42omo.useEffect)(()=>{
        if (shouldSkip) return;
        if (accessTypes && accessTypes.includes('VIEW') && !accessTypes.includes('EDIT')) {
            // Display the flag
            flags.showFlag({
                id: $4542b58e124be250$var$FLAG_ID,
                title: formatMessage($4542b58e124be250$var$i18n.title),
                customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                    color: "var(--ds-text-information, #1558BC)",
                    label: formatMessage($4542b58e124be250$var$i18n.title),
                    spacing: "spacious"
                }),
                description: formatMessage($4542b58e124be250$var$i18n.content),
                actions: [
                    {
                        content: formatMessage($4542b58e124be250$var$i18n.requestBtn),
                        onClick: requestAccess
                    }
                ],
                onClose: ()=>reportPopupEvent('dismiss')
            });
            // Event
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'flag',
                    actionSubjectId: 'showRequestToEditPopup',
                    source: 'requestAccessPopup',
                    attributes: {
                        contentId: contentId,
                        accessTypes: accessTypes.join(',')
                    }
                }
            }).fire();
        }
    }, [
        reportPopupEvent,
        requestAccess,
        flags,
        formatMessage,
        accessTypes,
        shouldSkip,
        contentId,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            flags.hideFlag($4542b58e124be250$var$FLAG_ID);
        };
    }, [
        flags
    ]);
};
// Currently there's a mix use of Atlaskit flags and Confluence flags.
// This component is using Confluence flags.
const $4542b58e124be250$var$RequestAccessPopupFlagWraper = ({ contentId: contentId, flags: flags })=>{
    $4542b58e124be250$export$a1b413940dee8e5e(contentId, flags);
    return null;
};
const $4542b58e124be250$export$8e100eba08cca59e = (0, $7aRa9.withFlags)($4542b58e124be250$var$RequestAccessPopupFlagWraper);
module.exports["useRequestAccessPopup"] = $4542b58e124be250$export$a1b413940dee8e5e;
module.exports["RequestAccessPopupComponent"] = $4542b58e124be250$export$8e100eba08cca59e;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("dmDX7", function(module, exports) {
/** @graphql cc **/ 
var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $eSUdr.default)`query usePendingRequestExistsQuery($accessRequestedAaid:String!$cloudId:ID!$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid cloudId:$cloudId contentId:$contentId){isPendingAccessRequestExists}}`;
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $42omo.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        }
    });
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("3aGPB", function(module, exports) {
/* GrantAccessDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $T1bCI = parcelRequire("T1bCI");


var $eSUdr = parcelRequire("eSUdr");


var $1DWH0 = parcelRequire("1DWH0");


var $cO1el = parcelRequire("cO1el");


var $eEA8O = parcelRequire("eEA8O");


var $30qWc = parcelRequire("30qWc");


var $9wGTI = parcelRequire("9wGTI");


var $gqqjz = parcelRequire("gqqjz");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $lsxnT = parcelRequire("lsxnT");

/**
 * @generated SignedSource<<f70cb19064aace212d3396de9f42cec6>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $1c9beeba0e68a72c$export$64ed4f32859160d1 = /*#__PURE__*/ function(AccessType) {
    AccessType["EDIT"] = "EDIT";
    AccessType["VIEW"] = "VIEW";
    return AccessType;
}({});


const $118c9dec782673ef$var$GrantAccessDialogGrantContentAccessMutation = (0, $eSUdr.default)`mutation GrantAccessDialogGrantContentAccessMutation($grantContentAccessInput:GrantContentAccessInput!){grantContentAccess(grantContentAccessInput:$grantContentAccessInput){success}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $118c9dec782673ef$var$DialogContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt44ar7 _1bsbkbql",
            __cmplp.className
        ])
    });
});
const $118c9dec782673ef$var$MessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _zulp1b66 _19pkutpp _otyrpxbi _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
$118c9dec782673ef$var$MessageContainer.displayName = 'MessageContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $118c9dec782673ef$var$ActionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _1bahh9n0",
            __cmplp.className
        ])
    });
});
const $118c9dec782673ef$var$DialogAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $118c9dec782673ef$var$i18n = (0, $cgtv4.defineMessages)({
    dialogTitleViewRequest: {
        id: "grant-access-dialog.dialog.title.view",
        defaultMessage: "View access request"
    },
    dialogTitleEditRequest: {
        id: "grant-access-dialog.dialog.title.edit",
        defaultMessage: "Edit access request"
    },
    grantViewAccess: {
        id: "grant-access-dialog.dialog.action.grant.view",
        defaultMessage: "Grant view access"
    },
    grantEditAccess: {
        id: "grant-access-dialog.dialog.action.grant.edit",
        defaultMessage: "Grant edit access"
    },
    denyAccess: {
        id: "grant-access-dialog.dialog.action.deny",
        defaultMessage: "Deny"
    },
    successTitle: {
        id: "grant-access-dialog.success.title",
        defaultMessage: "Access request granted"
    },
    errorTitle: {
        id: "grant-access-dialog.error.title",
        defaultMessage: "Access request error"
    },
    //412
    noMailServer: {
        id: "grant-access-dialog.error.no-mail-server",
        defaultMessage: "Access was granted, but there is not a mail server configured so the notification could not be sent."
    },
    //502
    sendEmailError: {
        id: "grant-access-dialog.error.send-email",
        defaultMessage: "Access was granted, but an unexpected error happened while sending the notification."
    },
    //every other error
    genericError: {
        id: "grant-access-dialog.error.generic",
        defaultMessage: "Sorry, there was an unexpected error while granting access."
    },
    //202
    alreadyGranted: {
        id: "grant-access-dialog.success.already-granted",
        defaultMessage: "Access was already granted to the user."
    },
    //other success
    genericSuccess: {
        id: "grant-access-dialog.success.generic",
        defaultMessage: "Access was granted, a notification to the user will be sent."
    },
    requestedViewAccess: {
        id: "grant-access-dialog.dialog.message.request.view.access.to.content",
        defaultMessage: "{person} requested view access to <b>{contentTitle}</b>."
    },
    requestedEditAccess: {
        id: "grant-access-dialog.dialog.message.request.edit.access.to.content",
        defaultMessage: "{person} requested edit access to <b>{contentTitle}</b>."
    }
});
const $118c9dec782673ef$var$GrantAccessDialogComponent = ({ accessType: accessType = 'view', isOpen: isOpen = false, onActionClick: onActionClick = ()=>{}, accountId: accountId, contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, intl: intl, displayName: displayName, children: children, contentTitle: contentTitle, profilePhoto: profilePhoto })=>{
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const generateAnalyticsProps = (0, $42omo.useCallback)(()=>({
            source: 'grantAccessDialog',
            attributes: {
                accessType: accessType
            }
        }), [
        accessType
    ]);
    (0, $42omo.useEffect)(()=>{
        if (createAnalyticsEvent) {
            const { attributes: attributes, source: source } = generateAnalyticsProps();
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'grantAccessScreen',
                    source: source,
                    attributes: {
                        ...attributes,
                        type: 'dialog'
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const generateGrantClickHandler = (0, $42omo.useCallback)((mutateGrantAccess)=>{
        const { attributes: attributes, source: source } = generateAnalyticsProps();
        return ()=>{
            createAnalyticsEvent && createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'grantAccess',
                    source: source,
                    attributes: attributes
                }
            }).fire();
            mutateGrantAccess({
                variables: {
                    grantContentAccessInput: {
                        contentId: contentId,
                        accessType: accessType === 'edit' ? (0, $1c9beeba0e68a72c$export$64ed4f32859160d1).EDIT : (0, $1c9beeba0e68a72c$export$64ed4f32859160d1).VIEW,
                        accountIdOrUsername: accountId
                    }
                }
            });
            if (onActionClick) onActionClick();
        };
    }, [
        accessType,
        accountId,
        onActionClick,
        contentId,
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const generateGrantAccessErrorHandler = (0, $42omo.useCallback)((flagsContainer)=>{
        const { formatMessage: formatMessage } = intl;
        const { attributes: attributes, source: source } = generateAnalyticsProps();
        const title = formatMessage($118c9dec782673ef$var$i18n.errorTitle);
        return (error)=>{
            const errorStatus = error?.graphQLErrors?.[0]?.message;
            let description;
            if (errorStatus === '412') description = formatMessage($118c9dec782673ef$var$i18n.noMailServer);
            else if (errorStatus === '502') description = formatMessage($118c9dec782673ef$var$i18n.sendEmailError);
            else description = formatMessage($118c9dec782673ef$var$i18n.genericError);
            // It's not clear whether this codepath is actually used for expected errors,
            // as comments elsewhere note that the experimental resolver results in
            // responseStatus=null for error state, which is handled by the success path.
            // Analytics should help us determine how/whether the error handling here is valid.
            createAnalyticsEvent && createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'error',
                    actionSubjectId: 'grantAccess',
                    source: source,
                    attributes: {
                        ...attributes,
                        errorStatus: errorStatus
                    }
                }
            }).fire();
            flagsContainer.showErrorFlag({
                title: title,
                description: description
            });
        };
    }, [
        intl,
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const generateGrantAccessSuccessHandler = (0, $42omo.useCallback)((flagsContainer)=>{
        const { formatMessage: formatMessage } = intl;
        const { attributes: attributes, source: source } = generateAnalyticsProps();
        return (response)=>{
            const success = response?.grantContentAccess?.success;
            if (!success) {
                createAnalyticsEvent && createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'accessRequest',
                        actionSubjectId: 'grantAccess',
                        source: source,
                        attributes: attributes
                    }
                }).fire();
                // experimental resolver throwing new error will result in responseStatus = null
                flagsContainer.showErrorFlag({
                    title: formatMessage($118c9dec782673ef$var$i18n.errorTitle),
                    description: formatMessage($118c9dec782673ef$var$i18n.genericError)
                });
                return;
            }
            createAnalyticsEvent && createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'granted',
                    actionSubject: 'access',
                    actionSubjectId: 'grantAccess',
                    source: source,
                    attributes: attributes
                }
            }).fire();
            flagsContainer.showSuccessFlag({
                title: formatMessage($118c9dec782673ef$var$i18n.successTitle),
                description: formatMessage($118c9dec782673ef$var$i18n.genericSuccess)
            });
        };
    }, [
        intl,
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const generateDenyAccessHandler = (0, $42omo.useCallback)(()=>{
        const { attributes: attributes, source: source } = generateAnalyticsProps();
        return ()=>{
            createAnalyticsEvent && createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'denyAccess',
                    source: source,
                    attributes: attributes
                }
            }).fire();
            if (onActionClick) onActionClick();
        };
    }, [
        onActionClick,
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const getContent = (0, $42omo.useCallback)((flagsContainer)=>{
        const requestedAccessCopy = accessType === 'view' ? $118c9dec782673ef$var$i18n.requestedViewAccess : $118c9dec782673ef$var$i18n.requestedEditAccess;
        const dialogTitle = accessType === 'view' ? $118c9dec782673ef$var$i18n.dialogTitleViewRequest : $118c9dec782673ef$var$i18n.dialogTitleEditRequest;
        const grantAccessButtonText = accessType === 'view' ? $118c9dec782673ef$var$i18n.grantViewAccess : $118c9dec782673ef$var$i18n.grantEditAccess;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($118c9dec782673ef$var$DialogContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "large",
            as: "h3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), dialogTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($118c9dec782673ef$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
            userId: accountId,
            name: displayName,
            src: profilePhoto,
            size: "xsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...requestedAccessCopy,
            values: {
                person: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                    userId: accountId,
                    fullName: displayName
                }),
                contentTitle: contentTitle,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($118c9dec782673ef$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            onClick: generateDenyAccessHandler(),
            testId: "deny-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $118c9dec782673ef$var$i18n.denyAccess)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ mutation: $118c9dec782673ef$var$GrantAccessDialogGrantContentAccessMutation,
            onError: generateGrantAccessErrorHandler(flagsContainer),
            onCompleted: generateGrantAccessSuccessHandler(flagsContainer)
        }, (mutateGrantAccess)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                onClick: generateGrantClickHandler(mutateGrantAccess),
                testId: "grant-button",
                appearance: "primary"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), grantAccessButtonText)))));
    }, [
        accessType,
        accountId,
        contentTitle,
        displayName,
        generateDenyAccessHandler,
        generateGrantAccessErrorHandler,
        generateGrantAccessSuccessHandler,
        generateGrantClickHandler,
        profilePhoto
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flagsContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
            isOpen: Boolean(isOpen),
            content: ()=>getContent(flagsContainer),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($118c9dec782673ef$var$DialogAnchor, {
                    "data-test-id": "inline-dialog-anchor",
                    ...triggerProps
                }, children),
            shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truepermissions')
        }));
};
const $118c9dec782673ef$export$6a13f73b981576d3 = (0, $1DWH0.default)()((0, $gmMgo.default)($118c9dec782673ef$var$GrantAccessDialogComponent));
module.exports["GrantAccessDialog"] = $118c9dec782673ef$export$6a13f73b981576d3;

});

parcelRegister("30qWc", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $308Wd = parcelRequire("308Wd");

const $9acca7871dfd8a5c$export$a59d7e865b63a081 = (0, $3u0dr.isReactCompilerActiveV2)() ? function MutationInterop(t0) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let mutation;
    let props;
    if ($[0] !== t0) {
        ({ children: children, mutation: mutation, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = mutation;
        $[3] = props;
    } else {
        children = $[1];
        mutation = $[2];
        props = $[3];
    }
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    let t1;
    if ($[4] !== children || $[5] !== mutate || $[6] !== result) {
        t1 = children(mutate, result);
        $[4] = children;
        $[5] = mutate;
        $[6] = result;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function MutationInterop({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
};
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("jJK3p", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $cgtv4.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $8C5kA.default)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("cPER9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $frIzR.c)(8);
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, ...otherProps } = props);
        $[0] = props;
        $[1] = href;
        $[2] = otherProps;
        $[3] = to;
    } else {
        href = $[1];
        otherProps = $[2];
        to = $[3];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[4] !== otherProps || $[5] !== props || $[6] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            ...props,
            href: t0,
            ...otherProps
        });
        $[4] = otherProps;
        $[5] = props;
        $[6] = t0;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("8lYIw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8T1Wf = parcelRequire("8T1Wf");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const $ = (0, $frIzR.c)(9);
    const { target: t0, name: name, href: t1, to: t2, params: t3 } = props;
    const target = t0 === undefined ? undefined : t0;
    const href = t1 === undefined ? null : t1;
    const to = t2 === undefined ? null : t2;
    const params = t3 === undefined ? {} : t3;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) {
        let t4;
        if ($[0] !== props || $[1] !== ref) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
                ...props,
                ref: ref,
                path: ""
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t4;
        } else t4 = $[2];
        return t4;
    }
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    let t4;
    if ($[3] !== match || $[4] !== path || $[5] !== props || $[6] !== ref || $[7] !== target) {
        t4 = match && target !== "_blank" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
            ...props,
            ref: ref,
            match: match
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
            ...props,
            ref: ref,
            path: path
        });
        $[3] = match;
        $[4] = path;
        $[5] = props;
        $[6] = ref;
        $[7] = target;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(21);
    let parentProps;
    let path;
    if ($[0] !== t0) {
        ({ path: path, ...parentProps } = t0);
        $[0] = t0;
        $[1] = parentProps;
        $[2] = path;
    } else {
        parentProps = $[1];
        path = $[2];
    }
    const { children: children, className: className, target: t1, testId: testId, style: style, id: id } = parentProps;
    const target = t1 === undefined ? undefined : t1;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    let t2;
    if ($[3] !== onPageReload || $[4] !== parentProps) {
        t2 = (e)=>{
            onPageReload(e.target.getAttribute("href"), false);
            if (parentProps.onClick) parentProps.onClick(e);
        };
        $[3] = onPageReload;
        $[4] = parentProps;
        $[5] = t2;
    } else t2 = $[5];
    const onAnchorLinkClick = t2;
    let t3;
    if ($[6] !== parentProps) {
        t3 = (e_0)=>{
            parentProps.onContextMenu?.(e_0);
        };
        $[6] = parentProps;
        $[7] = t3;
    } else t3 = $[7];
    const onAnchorContextMenuClick = t3;
    const t4 = target === "_blank" ? "noreferrer" : undefined;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[8] !== children || $[9] !== className || $[10] !== id || $[11] !== onAnchorContextMenuClick || $[12] !== onAnchorLinkClick || $[13] !== path || $[14] !== ref || $[15] !== style || $[16] !== t4 || $[17] !== t5 || $[18] !== target || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: path,
            className: className,
            onClick: onAnchorLinkClick,
            onContextMenu: onAnchorContextMenuClick,
            target: target,
            id: id,
            rel: t4,
            "data-testid": testId,
            ref: ref,
            "aria-label": t5,
            style: style
        }, children);
        $[8] = children;
        $[9] = className;
        $[10] = id;
        $[11] = onAnchorContextMenuClick;
        $[12] = onAnchorLinkClick;
        $[13] = path;
        $[14] = ref;
        $[15] = style;
        $[16] = t4;
        $[17] = t5;
        $[18] = target;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(22);
    let match;
    let parentProps;
    if ($[0] !== t0) {
        ({ match: match, ...parentProps } = t0);
        $[0] = t0;
        $[1] = match;
        $[2] = parentProps;
    } else {
        match = $[1];
        parentProps = $[2];
    }
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    let t1;
    if ($[3] !== match || $[4] !== preloadRoute) {
        t1 = async ()=>preloadRoute(match);
        $[3] = match;
        $[4] = preloadRoute;
        $[5] = t1;
    } else t1 = $[5];
    const onMouseDownCapture = t1;
    let t2;
    if ($[6] !== parentProps || $[7] !== routesContext) {
        t2 = (event)=>{
            if (parentProps.onClick) parentProps.onClick(event);
            const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
            if (!event.defaultPrevented && details?.href) {
                event.preventDefault();
                routesContext.push(details.href);
            }
        };
        $[6] = parentProps;
        $[7] = routesContext;
        $[8] = t2;
    } else t2 = $[8];
    const onClick = t2;
    let t3;
    if ($[9] !== parentProps) {
        t3 = (e)=>{
            parentProps.onContextMenu?.(e);
        };
        $[9] = parentProps;
        $[10] = t3;
    } else t3 = $[10];
    const onContextMenu = t3;
    const t4 = `${match.pathname}${match.search}${match.hash}`;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[11] !== children || $[12] !== className || $[13] !== id || $[14] !== onClick || $[15] !== onContextMenu || $[16] !== onMouseDownCapture || $[17] !== ref || $[18] !== style || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8T1Wf.Link), {
            to: t4,
            className: className,
            onClick: onClick,
            onContextMenu: onContextMenu,
            onMouseDownCapture: onMouseDownCapture,
            innerRef: ref,
            id: id,
            "aria-label": t5,
            style: style
        }, children);
        $[11] = children;
        $[12] = className;
        $[13] = id;
        $[14] = onClick;
        $[15] = onContextMenu;
        $[16] = onMouseDownCapture;
        $[17] = ref;
        $[18] = style;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("8T1Wf", function(module, exports) {

var $QU6QS = parcelRequire("QU6QS");


var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $fgJFQ = parcelRequire("fgJFQ");




var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $dRnqM = parcelRequire("dRnqM");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $6784f6b3e56cd8b3$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $6784f6b3e56cd8b3$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
var $6784f6b3e56cd8b3$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $fgJFQ.createLocation)(to, null, null, currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef === "undefined") $6784f6b3e56cd8b3$var$forwardRef = $6784f6b3e56cd8b3$var$forwardRefShim;
function $6784f6b3e56cd8b3$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $6784f6b3e56cd8b3$var$LinkAnchor = $6784f6b3e56cd8b3$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $bDniu.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $7Q5yr.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$6784f6b3e56cd8b3$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a = $6784f6b3e56cd8b3$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $6784f6b3e56cd8b3$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $bDniu.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var history = context.history;
        var location = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $7Q5yr.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $6784f6b3e56cd8b3$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $fgJFQ.createPath)(context.location) === (0, $fgJFQ.createPath)($6784f6b3e56cd8b3$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(component, props);
    });
});
var $6784f6b3e56cd8b3$var$toType, $6784f6b3e56cd8b3$var$refType;
var $6784f6b3e56cd8b3$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef$1 === "undefined") $6784f6b3e56cd8b3$var$forwardRef$1 = $6784f6b3e56cd8b3$var$forwardRefShim$1;
function $6784f6b3e56cd8b3$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $6784f6b3e56cd8b3$export$b0d92dbee9b5b60d = $6784f6b3e56cd8b3$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $bDniu.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $QU6QS.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $6784f6b3e56cd8b3$var$joinClassnames(className, activeClassName);
            style = (0, $7Q5yr.default)({}, style, activeStyle);
        }
        var props = (0, $7Q5yr.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim$1 !== $6784f6b3e56cd8b3$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6784f6b3e56cd8b3$export$a6c7ac8248d6e38a, props);
    });
});
var $6784f6b3e56cd8b3$var$ariaCurrentType;
module.exports["Link"] = $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a;

});

parcelRegister("fs6LW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $ecnYn.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $ecnYn.xcss)({
        display: 'flex'
    }),
    cursor: (0, $ecnYn.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $cgtv4.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $8C5kA.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = t12;
    } else t12 = $[22];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[23] = t14;
    } else t14 = $[23];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[24] !== t15 || $[25] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[24] = t15;
        $[25] = t16;
        $[26] = t17;
    } else t17 = $[26];
    let t18;
    if ($[27] !== getAriaProps) {
        t18 = getAriaProps();
        $[27] = getAriaProps;
        $[28] = t18;
    } else t18 = $[28];
    let t19;
    if ($[29] !== Icon || $[30] !== handleKeyDown || $[31] !== t17 || $[32] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[29] = Icon;
        $[30] = handleKeyDown;
        $[31] = t17;
        $[32] = t18;
        $[33] = t19;
    } else t19 = $[33];
    let t20;
    if ($[34] !== canViewProfile || $[35] !== isAnonymous || $[36] !== offset || $[37] !== position || $[38] !== t13 || $[39] !== t19 || $[40] !== trigger || $[41] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[34] = canViewProfile;
        $[35] = isAnonymous;
        $[36] = offset;
        $[37] = position;
        $[38] = t13;
        $[39] = t19;
        $[40] = trigger;
        $[41] = userId;
        $[42] = t20;
    } else t20 = $[42];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});


//# sourceMappingURL=RequestAccessPopup.78f0a524.js.map
